// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--32_Gn","Title":"Title--Z-L8L","Icon":"Icon--2l5Hs"};